import React, { memo, useRef, useEffect } from "react";
import { getClassNameFactory } from "@dcl/ui";
export var TableRadioBtn = function TableRadioBtn(_ref) {
  var id = _ref.id,
      ariaLabel = _ref.ariaLabel,
      checked = _ref.checked,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      tableRef = _ref.tableRef;
  var getClassName = getClassNameFactory(TableRadioBtn.displayName);
  var labelId = "".concat(id, "-label");
  var inputRef = useRef(null);
  var isRadioButtonForDataGridSelected = useRef(false);

  window.onload = function () {
    sessionStorage.removeItem("isRadioButtonForDataGridSelected");
  };

  useEffect(function () {
    isRadioButtonForDataGridSelected.current = sessionStorage.getItem("isRadioButtonForDataGridSelected") === "true";

    if (checked && inputRef.current && isRadioButtonForDataGridSelected.current) {
      inputRef.current.focus();
    }
  }, [checked, isRadioButtonForDataGridSelected]);
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (tableRef !== null && tableRef !== void 0 && tableRef.current && !tableRef.current.contains(event.target)) {
        sessionStorage.removeItem("isRadioButtonForDataGridSelected");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [tableRef]);

  var handleKeyPress = function handleKeyPress(event) {
    if (event.key === "Tab") {
      sessionStorage.removeItem("isRadioButtonForDataGridSelected");
      return;
    }

    event.preventDefault();
    var radios = Array.from(document.querySelectorAll("input[type='radio']"));
    isRadioButtonForDataGridSelected.current = true;
    sessionStorage.setItem("isRadioButtonForDataGridSelected", isRadioButtonForDataGridSelected.current.toString());
    var currentIndex = radios.indexOf(event.currentTarget);

    if (event.key === "ArrowDown") {
      var nextIndex = (currentIndex + 1) % radios.length;
      radios[nextIndex].click();
    } else if (event.key === "ArrowUp") {
      var prevIndex = (currentIndex - 1 + radios.length) % radios.length;
      radios[prevIndex].click();
    }
  };

  var renderTableRadioBtn = function renderTableRadioBtn() {
    return /*#__PURE__*/React.createElement("div", {
      "aria-hidden": true,
      className: getClassName({
        descendantName: "radio"
      })
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: getClassName(),
    key: id,
    role: "radio",
    "aria-checked": checked
  }, /*#__PURE__*/React.createElement("input", {
    id: id,
    key: id,
    radioGroup: "radio-group",
    ref: inputRef,
    "aria-checked": checked,
    onKeyDown: handleKeyPress,
    tabIndex: 0,
    "aria-labelledby": labelId,
    type: "radio",
    name: "table-selection",
    checked: checked,
    disabled: disabled,
    className: getClassName({
      descendantName: "input",
      utilities: "hiddenVisually"
    }),
    onChange: onChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    id: labelId
  }, renderTableRadioBtn(), /*#__PURE__*/React.createElement("p", {
    className: getClassName({
      utilities: "hiddenVisually"
    })
  }, ariaLabel)));
};
TableRadioBtn.displayName = "TableRadioBtn";
export default /*#__PURE__*/memo(TableRadioBtn);